const VALID_CONTACT_FORM_VARIANTS = ["v1", "v2", "v3"] as const;

export type ContactFormVariant = (typeof VALID_CONTACT_FORM_VARIANTS)[number];

export function isValidContactFormVariant(value: unknown): value is ContactFormVariant {
  return typeof value === "string" && VALID_CONTACT_FORM_VARIANTS.includes(value as ContactFormVariant);
}

export function resolveContactFormVariant(value: string | undefined): ContactFormVariant | undefined {
  return isValidContactFormVariant(value) ? value : undefined;
}
